import React, { useEffect, useState } from 'react';
import {
    Upload, Button, Table, Input, Tooltip, Breadcrumb, Avatar,
    Modal, Form, Select, InputNumber, message,
    Card, Row, Col, Statistic, Checkbox,
    Tag
} from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import {
    UploadOutlined, DeleteOutlined,
    HomeOutlined, PlusOutlined, DollarOutlined,
    UserOutlined, ShoppingOutlined, CheckCircleOutlined,
    ReloadOutlined
} from '@ant-design/icons';
import { fetchAchats, createManualAchat, getAchatFormData, fetchUnpaidAchats } from '../../../services/achat/admnAchatApi';
import BackupCodesModal from './modals/BackupCodesModal';
import { formateCoins, promotion } from '../../../function';
import ConfirmAchat from './modals/confirmAchat';
import ImageModal from '../../../components/imageModal';

const { Option } = Select;

const Achat = () => {
    const [montantCalculated, setMontantCalculated] = useState(0);
    const [montantOriginal, setMontantOriginal] = useState(0);
    const [modifierMontant, setModifierMontant] = useState(false);
    const [couponSelectionne, setCouponSelectionne] = useState(null);
    const [achats, setAchats] = useState([]);
    const [filters, setFilters] = useState({
        search: '',
        currentPage: 1,
        perPage: 10,
        date_debut: '',
        date_fin: '',
        offre_id: '',
        acheteur_id: '',
        coupon_id: '',
        type_offre_id: '',
        etat: ''
    });
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(true);
    const [backupCodes, setBackupCodes] = useState([]);
    const [isBackupCodesModalOpen, setIsBackupCodesModalOpen] = useState(false);
    const [achat, setAchat] = useState(null);
    const [isConfirmAchatModalOpen, setIsConfirmAchatModalOpen] = useState(false);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [isManualAchatModalOpen, setIsManualAchatModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [users, setUsers] = useState([]);
    const [offres, setOffres] = useState([]);
    const [coupons, setCoupons] = useState([]);
    const [typesOffre, setTypesOffre] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [stats, setStats] = useState({
        total_achats: 0,
        total_montant: 0,
        total_acheteurs: 0,
        achats_confirmes: 0,
        montant_confirmes: 0
    });

    const [unpaidAchats, setUnpaidAchats] = useState([]);
    const [isUnpaidModalOpen, setIsUnpaidModalOpen] = useState(false);
    const [unpaidLoading, setUnpaidLoading] = useState(false);
    const [unpaidTotalRows, setUnpaidTotalRows] = useState(0);
    const [unpaidFilters, setUnpaidFilters] = useState({
        currentPage: 1,
        perPage: 10,
        search: ''
    });

    const url_media = process.env.REACT_APP_MEDIA_URL || "https://api.masterfut.com/storage";

    // Format de date sans dayjs
    const formatDate = (dateString) => {
        if (!dateString) return '--';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // Format de date pour les inputs date
    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const showBackupCodes = (codes) => {
        setBackupCodes(codes);
        setIsBackupCodesModalOpen(true);
    };

    const showConfirmAchat = (achat) => {
        setAchat(achat);
        setIsConfirmAchatModalOpen(true);
    };

    const showImageModal = (images) => {
        const acheteurImage = images.find(image => image.type === 'acheteur');
        if (acheteurImage) {
            setImageUrl(`${acheteurImage.image}`);
            setIsImageModalOpen(true);
        } else {
            message.info('Aucune image disponible');
        }
    };

    const showManualAchatModal = () => {
        setIsManualAchatModalOpen(true);
        loadFormData();
    };

    useEffect(() => {
        loadAchats();
    }, [filters]);

    const loadAchats = () => {
        setLoading(true);

        fetchAchats(filters)
            .then((response) => {
                setAchats(response.achatOffres || []);
                setTotalRows(response.totalRows || 0);
                setStats(response.stats || {
                    total_achats: 0,
                    total_montant: 0,
                    total_acheteurs: 0,
                    achats_confirmes: 0,
                    montant_confirmes: 0
                });
                loadFormData();
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching achats:', error);
                toast.error('Erreur lors du chargement des achats.');
                setLoading(false);
            });
    };

    const loadUnpaidAchats = () => {
        setUnpaidLoading(true);
        fetchUnpaidAchats(unpaidFilters)
            .then((response) => {
                setUnpaidAchats(response.achatOffres || []);
                setUnpaidTotalRows(response.totalRows || 0);
                setUnpaidLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching unpaid achats:', error);
                toast.error('Erreur lors du chargement des clics.');
                setUnpaidLoading(false);
            });
    };

    useEffect(() => {
        if (isUnpaidModalOpen) {
            loadUnpaidAchats();
        }
    }, [unpaidFilters, isUnpaidModalOpen]);

    const showUnpaidModal = () => {
        setIsUnpaidModalOpen(true);
    };

    const loadFormData = async () => {
        try {
            console.log('Loading form data...');
            const response = await getAchatFormData();
            console.log('Form data response:', response);

            if (response.status === 'success') {
                setUsers(response.data.acheteurs || []);
                setOffres(response.data.offres || []);
                setCoupons(response.data.coupons || []);
                setTypesOffre(response.data.types_offre || []);

                console.log('Users loaded:', response.data.acheteurs?.length);
                console.log('Offres loaded:', response.data.offres?.length);
            } else {
                console.error('API response not successful:', response);
            }
        } catch (error) {
            console.error('Error loading form data:', error);
            toast.error('Erreur lors du chargement des données du formulaire');
        }
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value,
            currentPage: key === 'currentPage' ? value : 1 // Reset to first page when filter changes
        }));
    };

    const handleDateRangeChange = (event, type) => {
        const value = event.target.value;
        if (type === 'start') {
            setFilters(prev => ({
                ...prev,
                date_debut: value,
                currentPage: 1
            }));
        } else {
            setFilters(prev => ({
                ...prev,
                date_fin: value,
                currentPage: 1
            }));
        }
    };

    const resetFilters = () => {
        setFilters({
            search: '',
            currentPage: 1,
            perPage: 10,
            date_debut: '',
            date_fin: '',
            offre_id: '',
            acheteur_id: '',
            coupon_id: '',
            type_offre_id: '',
            etat: ''
        });
    };

    const handleManualAchatSubmit = async (values) => {
        setSubmitting(true);
        try {
            const formData = new FormData();

            // Ajouter les données principales
            formData.append('acheteur_id', values.acheteur_id);
            formData.append('offre_id', values.offre_id);
            formData.append('date_achat', values.date_achat);
            formData.append('login', values.login);
            formData.append('password', values.password);
            formData.append('etat', values.etat);
            formData.append('montant', values.montant);

            // Ajouter les codes de sauvegarde
            values.backup_codes.forEach((code, index) => {
                if (code && code.trim() !== '') {
                    formData.append('backup_codes[]', code);
                }
            });

            // Ajouter le coupon si sélectionné
            if (values.coupon_id) {
                formData.append('coupon_id', values.coupon_id);
            }

            // Ajouter l'image si fournie
            if (values.image && values.image.length > 0) {
                const imageFile = values.image[0].originFileObj;
                if (imageFile) {
                    formData.append('image', imageFile);
                }
            }

            const response = await createManualAchat(formData);

            if (response.status === 'success') {
                message.success('Achat créé avec succès!');
                setIsManualAchatModalOpen(false);
                form.resetFields();
                loadAchats(); // Recharger la liste
            } else {
                message.error(response.message || 'Erreur lors de la création');
            }
        } catch (error) {
            console.error('Error creating manual achat:', error);
            message.error('Erreur lors de la création de l\'achat');
        } finally {
            setSubmitting(false);
        }
    };

    // Fonction pour calculer la réduction
    const calculerReduction = (montant, coupon) => {
        if (!coupon) return 0;

        if (coupon.type === 'fixed') {
            return coupon.value;
        } else if (coupon.type === 'percentage') {
            return montant * (coupon.value / 100);
        }
        return 0;
    };

    // Fonction pour calculer le montant final
    const calculerMontantFinal = (montant, coupon) => {
        if (!coupon) return montant;

        if (coupon.type === 'fixed') {
            return Math.max(0, montant - coupon.value);
        } else if (coupon.type === 'percentage') {
            const reduction = montant * (coupon.value / 100);
            return Math.max(0, montant - reduction);
        }
        return montant;
    };

    // Fonction pour gérer le changement de coupon
    const handleCouponChange = (couponId) => {
        const coupon = coupons.find(c => c.id === couponId);
        setCouponSelectionne(coupon);

        // Recalculer le montant
        const montantBase = montantOriginal;
        let montantFinal = montantBase;

        if (coupon) {
            montantFinal = calculerMontantFinal(montantBase, coupon);
        }

        setMontantCalculated(montantFinal);

        // Mettre à jour le champ montant si non modifié manuellement
        if (!modifierMontant) {
            form.setFieldsValue({
                montant: montantFinal
            });
        }
    };

    // Modifier handleOffreChange
    const handleOffreChange = (offreId) => {
        const selectedOffre = offres.find(offre => offre.id === offreId);
        if (selectedOffre) {
            const montantBase = selectedOffre.montant;
            setMontantOriginal(montantBase);

            let montantFinal = montantBase;

            // Appliquer la réduction du coupon si sélectionné
            if (couponSelectionne) {
                montantFinal = calculerMontantFinal(montantBase, couponSelectionne);
            }

            setMontantCalculated(montantFinal);

            // Mettre à jour le champ montant
            form.setFieldsValue({
                montant: modifierMontant ? undefined : montantFinal
            });
        } else {
            setMontantOriginal(0);
            setMontantCalculated(0);
            form.setFieldsValue({
                montant: 0
            });
        }
    };

    const columns = [
        {
            title: 'Acheteur',
            dataIndex: 'acheteur',
            key: 'acheteur',
            width: 200,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar
                        src={record.acheteur?.photo_profil ? `${url_media}/${record.acheteur.photo_profil}` : undefined}
                        style={{
                            background: record.acheteur?.photo_profil ? undefined : "var(--primary-color) !important",
                            color: 'white',
                        }}
                    >
                        <h5 style={{ marginTop: 1 }}>
                            {record.acheteur?.photo_profil ? null : record.acheteur?.username?.charAt(0)?.toUpperCase() || 'U'}
                        </h5>
                    </Avatar>
                    <div style={{ marginLeft: 8 }}>
                        <p style={{ margin: 0, fontWeight: 'bold', color: "var(--primary-color)" }}>{record.acheteur?.username || 'N/A'}</p>
                        <p style={{ margin: 0, fontSize: '12px', color: "var(--primary-color)" }}>{record.acheteur?.email || 'N/A'}</p>
                    </div>
                </div>
            ),
        },
        {
            title: 'Date d\'Achat',
            dataIndex: 'date_achat',
            key: 'date_achat',
            width: 120,
            render: (text) => (
                <p style={{ textAlign: 'center', margin: 0, color: "var(--primary-color)" }}>
                    {formatDate(text)}
                </p>
            ),
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            width: 120,
            render: (text, record) => (
                <span style={{ color: "var(--primary-color)" }}>{record.offre?.type?.nom || '--'}</span>
            ),
        },
        {
            title: 'Payment Method',
            dataIndex: 'payment_method',
            key: 'payment_method',
            width: 120,
            render: (text) => <span style={{ color: "var(--primary-color)" }}>{text || '--'}</span>,
        },
        {
            title: 'État',
            dataIndex: 'etat',
            key: 'etat',
            width: 100,
            render: (text) => {
                const getEtatColor = (etat) => {
                    switch (etat) {
                        case 'confirme': return '#52c41a';
                        case 'enattente': return '#faad14';
                        case 'annule': return '#ff4d4f';
                        case 'rembourse': return '#1890ff';
                        default: return '#d9d9d9';
                    }
                };

                return (
                    <span
                        style={{
                            color: getEtatColor(text),
                            fontWeight: 'bold'
                        }}
                    >
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Login',
            dataIndex: 'login',
            key: 'login',
            width: 120,
            render: (text) => <span style={{ color: "var(--primary-color)" }}>{text}</span>,
        },
        {
            title: 'Password',
            dataIndex: 'password',
            key: 'password',
            width: 120,
            render: (text) => <span style={{ color: "var(--primary-color)" }}>{text}</span>,
        },
        {
            title: 'Montant',
            dataIndex: 'montant',
            key: 'montant',
            width: 100,
            render: (text, record) => (
                <span style={{ fontWeight: 'bold', color: '#1890ff' }}>
                    {record.formatted_price ? record.formatted_price : (record.offre ? `${record.montant} ${record.currency_payment === 'EUR' ? '€' : '$'}` : '--')}
                </span>
            ),
        },
        {
            title: 'Coins',
            dataIndex: 'coins',
            key: 'coins',
            width: 100,
            render: (text, record) => (
                <p style={{ margin: 0, fontWeight: 'bold', color: "var(--primary-color)" }}>
                    {record.offre ? formateCoins(record.offre.coins) : '--'}
                </p>
            ),
        },
        {
            title: 'Coupon',
            dataIndex: 'coupon',
            key: 'coupon',
            width: 100,
            render: (text, record) => (
                <span style={{ color: "var(--primary-color)" }}>{record.coupon?.code || '--'}</span>
            ),
        },
        {
            title: 'Backup Codes',
            dataIndex: 'backup_codes',
            key: 'backup_codes',
            width: 100,
            render: (text, record) => (
                <Tooltip title="Voir les codes de sauvegarde">
                    <Button
                        type='primary'
                        className='border border-primary'
                        shape='circle'
                        onClick={() => showBackupCodes(record.backups || [])}
                        disabled={!record.backups || record.backups.length === 0}
                        style={{
                            backgroundColor: "var(--primary-color3)",
                            borderColor: "var(--primary-color3)"
                        }}
                    >
                        <i className="bi bi-eye" />
                    </Button>
                </Tooltip>
            ),
        },
        {
            title: 'Whatsapp',
            dataIndex: 'whatsapp',
            key: 'whatsapp',
            width: 130,
            render: (text, record) => (
                <p style={{ margin: 0, color: "var(--primary-color)" }}>{record.acheteur?.whatssap || '--'}</p>
            ),
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: 'image',
            width: 80,
            render: (text, record) => (
                <Tooltip title="Voir l'image de preuve">
                    <Button
                        type='primary'
                        className='border border-primary'
                        shape='circle'
                        onClick={() => showImageModal(record.achat_images || [])}
                        disabled={!record.achat_images || record.achat_images.length === 0}
                        style={{
                            backgroundColor: "var(--primary-color3)",
                            borderColor: "var(--primary-color3)"
                        }}
                    >
                        <i className="bi bi-eye" />
                    </Button>
                </Tooltip>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 80,
            fixed: 'right',
            render: (text, record) => (
                <Tooltip title={record.etat === 'confirme' ? 'Déjà confirmé' : 'Confirmer cet achat'}>
                    <Button
                        disabled={record.etat === 'confirme'}
                        type='primary'
                        className='border border-primary'
                        shape='circle'
                        onClick={() => showConfirmAchat(record)}
                        style={{
                            backgroundColor: record.etat === 'confirme' ? '#d9d9d9' : "var(--primary-color3)",
                            borderColor: record.etat === 'confirme' ? '#d9d9d9' : "var(--primary-color3)"
                        }}
                    >
                        <i className="bi bi-check" />
                    </Button>
                </Tooltip>
            ),
        },
    ];

    return (
        <>
            <div style={{
                padding: '20px',
                backgroundColor: "var(--background-body)",
                minHeight: '100vh'
            }}>
                {/* En-tête avec titre et bouton */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div>
                        <div className="mb-2">
                            <i className="bx bx-tag me-2" style={{ color: "var(--primary-color3) !important" }} />
                            <h3 style={{ color: "var(--primary-color3) !important", margin: 0, display: 'inline' }}>Achats</h3>
                        </div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <HomeOutlined style={{ color: "var(--primary-color)" }} />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item style={{ color: "var(--primary-color3) !important" }}>Achats</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={showManualAchatModal}
                        style={{
                            backgroundColor: 'var(--primary-color3)',
                            borderColor: 'var(--primary-color3)',
                        }}
                    >
                        Ajouter Achat Manuel
                    </Button>
                </div>

                {/* Cartes de statistiques */}
                <Row gutter={16} style={{ marginBottom: '20px' }}>
                    <Col xs={24} sm={12} md={6}>
                        <Card
                            style={{
                                backgroundColor: "var(--background-body)",
                                border: "1px solid var(--primary-color6)",
                                cursor: 'pointer'
                            }}
                            onClick={showUnpaidModal}
                        >
                            <Statistic
                                title={<span style={{ color: "var(--primary-color)" }}>Total Achats</span>}
                                value={`${stats.total_achats}/ ${stats.totalclicks} Clicks`}
                                prefix={<ShoppingOutlined style={{ color: "var(--primary-color3)" }} />}
                                valueStyle={{ color: "var(--primary-color)" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card style={{ backgroundColor: "var(--background-body)", border: "1px solid var(--primary-color6)" }}>
                            <Statistic
                                title={<span style={{ color: "var(--primary-color)" }}>Montant Total</span>}
                                value={stats.total_montant}
                                precision={2}
                                prefix={<DollarOutlined style={{ color: "var(--primary-color3)" }} />}
                                suffix="USD"
                                valueStyle={{ color: "var(--primary-color)" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card style={{ backgroundColor: "var(--background-body)", border: "1px solid var(--primary-color6)" }}>
                            <Statistic
                                title={<span style={{ color: "var(--primary-color)" }}>Total Acheteurs</span>}
                                value={stats.total_acheteurs}
                                prefix={<UserOutlined style={{ color: "var(--primary-color3)" }} />}
                                valueStyle={{ color: "var(--primary-color)" }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card style={{ backgroundColor: "var(--background-body)", border: "1px solid var(--primary-color6)" }}>
                            <Statistic
                                title={<span style={{ color: "var(--primary-color)" }}>Achats Confirmés</span>}
                                value={stats.achats_confirmes}
                                prefix={<CheckCircleOutlined style={{ color: "var(--primary-color3)" }} />}
                                valueStyle={{ color: "var(--primary-color)" }}
                            />
                        </Card>
                    </Col>
                </Row>

                {/* Filtres avancés */}
                <Card
                    title={
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            <span style={{
                                color: "var(--primary-color)",
                                fontSize: '16px',
                                fontWeight: '600'
                            }}>
                                Filtres de recherche
                            </span>
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={resetFilters}
                                size="small"
                                style={{
                                    color: "var(--primary-color)",
                                    border: "1px solid var(--primary-color6)",
                                    backgroundColor: "var(--background-body)"
                                }}
                            >
                                Réinitialiser
                            </Button>
                        </div>
                    }
                    style={{
                        marginBottom: '20px',
                        backgroundColor: "var(--background-body)",
                        border: "1px solid var(--primary-color6)",
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                    }}
                    bodyStyle={{
                        padding: '16px',
                        backgroundColor: "var(--background-body)"
                    }}
                >
                    {/* Version Mobile - Filtres empilés */}
                    <div className="mobile-filters" style={{ display: { xs: 'block', sm: 'none' } }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

                            {/* Recherche mobile */}
                            <div>
                                <Input
                                    placeholder="🔍 Rechercher..."
                                    value={filters.search}
                                    onChange={(e) => handleFilterChange('search', e.target.value)}
                                    style={{
                                        backgroundColor: "var(--background-body)",
                                        color: "var(--primary-color)",
                                        border: "1px solid var(--primary-color6)",
                                        borderRadius: '8px',
                                        padding: '12px'
                                    }}
                                />
                            </div>

                            {/* Dates mobiles */}
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '12px',
                                        color: "var(--primary-color)",
                                        marginBottom: '4px',
                                        fontWeight: '500'
                                    }}>
                                        Date début
                                    </label>
                                    <input
                                        type="date"
                                        value={filters.date_debut}
                                        onChange={(e) => handleDateRangeChange(e, 'start')}
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid var(--primary-color6)',
                                            borderRadius: '8px',
                                            backgroundColor: "var(--background-body)",
                                            color: "var(--primary-color)",
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '12px',
                                        color: "var(--primary-color)",
                                        marginBottom: '4px',
                                        fontWeight: '500'
                                    }}>
                                        Date fin
                                    </label>
                                    <input
                                        type="date"
                                        value={filters.date_fin}
                                        onChange={(e) => handleDateRangeChange(e, 'end')}
                                        style={{
                                            width: '100%',
                                            padding: '8px',
                                            border: '1px solid var(--primary-color6)',
                                            borderRadius: '8px',
                                            backgroundColor: "var(--background-body)",
                                            color: "var(--primary-color)",
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Filtres mobiles en ligne */}
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                <div style={{ flex: 1, minWidth: '120px' }}>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '12px',
                                        color: "var(--primary-color)",
                                        marginBottom: '4px',
                                        fontWeight: '500'
                                    }}>
                                        État
                                    </label>
                                    <Select
                                        placeholder="📊 État"
                                        style={{ width: '100%' }}
                                        value={filters.etat || undefined}
                                        onChange={(value) => handleFilterChange('etat', value)}
                                        allowClear
                                        size="small"
                                        dropdownStyle={{
                                            backgroundColor: "var(--background-body)",
                                            border: "1px solid var(--primary-color6)"
                                        }}
                                    >
                                        <Option style={{ color: "var(--primary-color)" }} value="confirme">✅ Confirmé</Option>
                                        <Option style={{ color: "var(--primary-color)" }} value="enattente">⏳ En attente</Option>
                                        <Option style={{ color: "var(--primary-color)" }} value="annule">❌ Annulé</Option>
                                        <Option style={{ color: "var(--primary-color)" }} value="rembourse">💸 Remboursé</Option>
                                    </Select>
                                </div>

                                <div style={{ flex: 1, minWidth: '120px' }}>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '12px',
                                        color: "var(--primary-color)",
                                        marginBottom: '4px',
                                        fontWeight: '500'
                                    }}>
                                        Acheteur {users.length > 0 && `(${users.length})`}
                                    </label>
                                    <Select
                                        placeholder={users.length > 0 ? "👤 Acheteur" : "⏳ Chargement..."}
                                        style={{ width: '100%' }}
                                        value={filters.acheteur_id || undefined}
                                        onChange={(value) => handleFilterChange('acheteur_id', value)}
                                        showSearch
                                        size="small"
                                        allowClear
                                        loading={!users.length}
                                        filterOption={(input, option) => {
                                            // Recherche dans le username et l'email
                                            const user = users.find(u => u.id === option.value);
                                            if (!user) return false;

                                            const searchText = input.toLowerCase();
                                            return (
                                                user.username?.toLowerCase().includes(searchText) ||
                                                user.email?.toLowerCase().includes(searchText)
                                            );
                                        }}
                                        optionFilterProp="children"
                                        dropdownStyle={{
                                            backgroundColor: "var(--background-body)",
                                            border: "1px solid var(--primary-color6)"
                                        }}
                                    >
                                        {console.log('Users data for filter:', users)}
                                        {users.length > 0 ? (
                                            users.map(user => (
                                                <Option
                                                    key={user.id}
                                                    value={user.id}
                                                    style={{ color: "var(--primary-color)" }}
                                                >
                                                    <div>
                                                        <div style={{ fontWeight: '500' }}>
                                                            {user.username}
                                                        </div>
                                                        <div style={{ fontSize: '11px' }}>
                                                            {user.email}
                                                        </div>
                                                    </div>
                                                </Option>
                                            ))
                                        ) : (
                                            <Option disabled value="loading">
                                                ⏳ Chargement des acheteurs...
                                            </Option>
                                        )}
                                    </Select>
                                </div>

                                <div style={{ flex: 1, minWidth: '120px' }}>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '12px',
                                        color: "var(--primary-color)",
                                        marginBottom: '4px',
                                        fontWeight: '500'
                                    }}>
                                        Offre {offres.length > 0 && `(${offres.length})`}
                                    </label>
                                    <Select
                                        placeholder={offres.length > 0 ? "🎁 Offre" : "⏳ Chargement..."}
                                        style={{ width: '100%' }}
                                        value={filters.offre_id || undefined}
                                        onChange={(value) => handleFilterChange('offre_id', value)}
                                        showSearch
                                        size="small"
                                        allowClear
                                        loading={!offres.length}
                                        filterOption={(input, option) => {
                                            // Recherche dans le titre, type et coins
                                            const offre = offres.find(o => o.id === option.value);
                                            if (!offre) return false;

                                            const searchText = input.toLowerCase();
                                            const offreText = `${offre.titre} ${offre.type?.nom} ${formateCoins(offre.coins)} ${offre.montant}`.toLowerCase();

                                            return offreText.includes(searchText);
                                        }}
                                        optionFilterProp="children"
                                        dropdownStyle={{
                                            backgroundColor: "var(--background-body)",
                                            border: "1px solid var(--primary-color6)"
                                        }}
                                    >
                                        {console.log('Offres data for filter:', offres)}
                                        {offres.length > 0 ? (
                                            offres.map(offre => (
                                                <Option
                                                    key={offre.id}
                                                    value={offre.id}
                                                    style={{ color: "var(--primary-color)" }}
                                                >
                                                    <div>
                                                        <div style={{ fontWeight: '500' }}>
                                                            {formateCoins(offre.coins)} - {offre.montant} USD
                                                        </div>
                                                        <div style={{ fontSize: '11px' }}>
                                                            {offre.titre} • {offre.type?.nom || 'Type inconnu'}
                                                        </div>
                                                    </div>
                                                </Option>
                                            ))
                                        ) : (
                                            <Option disabled value="loading">
                                                ⏳ Chargement des offres...
                                            </Option>
                                        )}
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Indicateurs de filtres actifs */}
                    {(filters.search || filters.date_debut || filters.date_fin || filters.etat || filters.acheteur_id || filters.offre_id) && (
                        <div style={{
                            marginTop: '16px',
                            padding: '8px 12px',
                            // backgroundColor: 'var(--primary-color3)',
                            borderRadius: '6px',
                            border: '1px solid var(--primary-color6)'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                gap: '8px'
                            }}>
                                <span style={{
                                    color: "var(--primary-color)",
                                    fontSize: '12px',
                                    fontWeight: '500'
                                }}>
                                    🎯 Filtres actifs:
                                </span>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    {filters.search && (
                                        <Tag color="blue" style={{ margin: 0, fontSize: '11px' }}>
                                            🔍 {filters.search}
                                        </Tag>
                                    )}
                                    {filters.date_debut && filters.date_fin && (
                                        <Tag color="green" style={{ margin: 0, fontSize: '11px' }}>
                                            📅 {filters.date_debut} → {filters.date_fin}
                                        </Tag>
                                    )}
                                    {filters.etat && (
                                        <Tag color="orange" style={{ margin: 0, fontSize: '11px' }}>
                                            📊 {filters.etat}
                                        </Tag>
                                    )}
                                    {filters.acheteur_id && (
                                        <Tag color="purple" style={{ margin: 0, fontSize: '11px' }}>
                                            👤 {users.find(u => u.id === filters.acheteur_id)?.username}
                                        </Tag>
                                    )}
                                    {filters.offre_id && (
                                        <Tag color="cyan" style={{ margin: 0, fontSize: '11px' }}>
                                            🎁 {offres.find(o => o.id === filters.offre_id)?.titre}
                                        </Tag>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Card>

                {/* Tableau des achats */}
                <Card style={{
                    backgroundColor: "var(--background-body)",
                    border: "1px solid var(--primary-color6)"
                }}>
                    <Table
                        dataSource={achats}
                        columns={columns}
                        pagination={{
                            current: filters.currentPage,
                            total: totalRows,
                            pageSize: filters.perPage,
                            onChange: (page) => handleFilterChange('currentPage', page),
                            onShowSizeChange: (current, size) => handleFilterChange('perPage', size),
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} sur ${total} achats`,
                            pageSizeOptions: ['10', '20', '50', '100']
                        }}
                        scroll={{ x: 1500 }}
                        loading={loading}
                        rowKey="id"
                    />
                </Card>
            </div>

            {/* Modal pour l'ajout manuel d'achat */}
            <Modal
                title="Ajouter un Achat Manuel"
                open={isManualAchatModalOpen}
                onCancel={() => {
                    setIsManualAchatModalOpen(false);
                    setModifierMontant(false);
                    setCouponSelectionne(null);
                }}
                footer={null}
                width={700}
                style={{ top: 20 }}
                styles={{
                    body: {
                        backgroundColor: "var(--background-body)",
                        color: "var(--primary-color)"
                    }
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleManualAchatSubmit}
                    initialValues={{
                        date_achat: formatDateForInput(new Date()),
                        etat: 'confirme',
                        backup_codes: [''],
                        montant: 0,
                        modifier_montant: false
                    }}
                >
                    <div style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '10px' }}>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item
                                    label="Acheteur"
                                    name="acheteur_id"
                                    rules={[{ required: true, message: 'Veuillez sélectionner un acheteur' }]}
                                >
                                    <Select
                                        placeholder="Sélectionner un acheteur"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                            const children = option?.children || '';
                                            return children.toString().toLowerCase().includes(input.toLowerCase());
                                        }}
                                        style={{ width: '100%' }}
                                    >
                                        {users.map(user => (
                                            <Option key={user.id} value={user.id}>
                                                {user.username} ({user.email})
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                <Form.Item
                                    label="Offre"
                                    name="offre_id"
                                    rules={[{ required: true, message: 'Veuillez sélectionner une offre' }]}
                                >
                                    <Select
                                        placeholder="Sélectionner une offre"
                                        showSearch
                                        optionFilterProp="children"
                                        onChange={handleOffreChange}
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase?.().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {offres.map(offre => (
                                            <Option key={offre.id} value={offre.id}>
                                                {formateCoins(offre.coins)} - {offre.montant} USD - {offre.type?.nom || 'Type inconnu'}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item
                                    label="Date d'achat"
                                    name="date_achat"
                                    rules={[{ required: true, message: 'Veuillez sélectionner une date' }]}
                                >
                                    <input
                                        type="date"
                                        style={{
                                            width: '100%',
                                            padding: '8px 12px',
                                            border: '1px solid var(--primary-color6)',
                                            borderRadius: '6px',
                                            backgroundColor: "var(--background-body)",
                                            color: "var(--primary-color)"
                                        }}
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                <Form.Item
                                    label="État"
                                    name="etat"
                                    rules={[{ required: true, message: 'Veuillez sélectionner un état' }]}
                                >
                                    <Select placeholder="Sélectionner un état">
                                        <Option value="confirme">Confirmé</Option>
                                        <Option value="enattente">En attente</Option>
                                        <Option value="annule">Annulé</Option>
                                        <Option value="rembourse">Remboursé</Option>
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item
                                    label="Login"
                                    name="login"
                                    rules={[{ required: true, message: 'Veuillez saisir le login' }]}
                                >
                                    <Input
                                        placeholder="Saisir le login"
                                        style={{
                                            backgroundColor: "var(--background-body)",
                                            color: "var(--primary-color)",
                                            border: "1px solid var(--primary-color6)"
                                        }}
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-md-6">
                                <Form.Item
                                    label="Mot de passe"
                                    name="password"
                                    rules={[{ required: true, message: 'Veuillez saisir le mot de passe' }]}
                                >
                                    <Input.Password
                                        placeholder="Saisir le mot de passe"
                                        style={{
                                            backgroundColor: "var(--background-body)",
                                            color: "var(--primary-color)",
                                            border: "1px solid var(--primary-color6)"
                                        }}
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item
                                    label="Coupon"
                                    name="coupon_id"
                                >
                                    <Select
                                        placeholder="Sélectionner un coupon (optionnel)"
                                        onChange={handleCouponChange}
                                        allowClear
                                    >
                                        <Option value="">Aucun coupon</Option>
                                        {coupons.map(coupon => (
                                            <Option key={coupon.id} value={coupon.id}>
                                                {coupon.code} -
                                                {coupon.type === 'percentage'
                                                    ? `${coupon.value}% de réduction`
                                                    : `${coupon.value}$ de réduction`
                                                }
                                                {coupon.min_amount && ` (Min: ${coupon.min_amount}$)`}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                {/* Affichage du calcul */}
                                <div style={{
                                    padding: '10px',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '6px',
                                    marginBottom: '16px'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                        <span style={{ color: "var(--primary-color)" }}>Montant original:</span>
                                        <span style={{ fontWeight: 'bold', color: "var(--primary-color)" }}>{montantOriginal.toFixed(2)} $</span>
                                    </div>
                                    {couponSelectionne && (
                                        <>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                <span style={{ color: "var(--primary-color)" }}>Coupon ({couponSelectionne.code}):</span>
                                                <span style={{ color: "var(--primary-color)" }}>
                                                    {couponSelectionne.type === 'percentage'
                                                        ? `${couponSelectionne.value}%`
                                                        : `${couponSelectionne.value}$`
                                                    }
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                                                <span style={{ color: "var(--primary-color)" }}>Réduction appliquée:</span>
                                                <span style={{ color: '#52c41a', fontWeight: 'bold' }}>
                                                    -{calculerReduction(montantOriginal, couponSelectionne).toFixed(2)} $
                                                    {couponSelectionne.type === 'percentage' &&
                                                        ` (${couponSelectionne.value}% de ${montantOriginal.toFixed(2)}$)`
                                                    }
                                                </span>
                                            </div>
                                        </>
                                    )}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #ddd', paddingTop: '5px' }}>
                                        <span style={{ fontWeight: 'bold', color: "var(--primary-color)" }}>Montant final:</span>
                                        <span style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                            {montantCalculated.toFixed(2)} $
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <Form.Item
                                    label="Montant à payer (USD)"
                                    name="montant"
                                    rules={[{ required: true, message: 'Veuillez saisir le montant' }]}
                                >
                                    <InputNumber
                                        style={{ width: '100%' }}
                                        min={0}
                                        step={0.01}
                                        placeholder="Montant final"
                                        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        disabled={!modifierMontant}
                                        value={modifierMontant ? undefined : montantCalculated}
                                    />
                                </Form.Item>

                                <Form.Item name="modifier_montant" valuePropName="checked">
                                    <Checkbox
                                        onChange={(e) => {
                                            setModifierMontant(e.target.checked);
                                            if (!e.target.checked) {
                                                form.setFieldsValue({
                                                    montant: montantCalculated
                                                });
                                            }
                                        }}
                                    >
                                        <span style={{ color: "var(--primary-color)" }}>Modifier manuellement le montant</span>
                                    </Checkbox>
                                </Form.Item>
                            </div>
                        </div>

                        {/* Codes de sauvegarde */}
                        <Form.Item
                            label={<span style={{ color: "var(--primary-color)" }}>Codes de sauvegarde</span>}
                            required
                        >
                            <Form.List name="backup_codes">
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map((field, index) => (
                                            <div key={field.key} style={{ display: 'flex', marginBottom: 8, alignItems: 'center' }}>
                                                <Form.Item
                                                    {...field}
                                                    style={{ flex: 1, marginBottom: 0 }}
                                                    rules={[
                                                        { required: true, message: 'Code requis' },
                                                        { min: 1, message: 'Le code ne peut pas être vide' }
                                                    ]}
                                                >
                                                    <Input
                                                        placeholder={`Code de sauvegarde ${index + 1}`}
                                                        style={{
                                                            backgroundColor: "var(--background-body)",
                                                            color: "var(--primary-color)",
                                                            border: "1px solid var(--primary-color6)"
                                                        }}
                                                    />
                                                </Form.Item>
                                                {fields.length > 1 && (
                                                    <Button
                                                        type="primary"
                                                        danger
                                                        onClick={() => remove(field.name)}
                                                        style={{ marginLeft: 8 }}
                                                        icon={<DeleteOutlined />}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                        <Button
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined />}
                                            style={{ marginTop: 8 }}
                                        >
                                            Ajouter un code
                                        </Button>
                                    </>
                                )}
                            </Form.List>
                        </Form.Item>

                        <Form.Item
                            label={<span style={{ color: "var(--primary-color)" }}>Image de preuve</span>}
                            name="image"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => {
                                if (Array.isArray(e)) {
                                    return e;
                                }
                                return e && e.fileList;
                            }}
                        >
                            <Upload
                                name="image"
                                listType="picture"
                                accept="image/*"
                                beforeUpload={() => false} // Empêche l'upload automatique
                                maxCount={1}
                                onRemove={() => {
                                    form.setFieldsValue({ image: undefined });
                                }}
                            >
                                <Button icon={<UploadOutlined />}>Sélectionner l'image</Button>
                            </Upload>
                        </Form.Item>
                    </div>

                    <div style={{ marginTop: 20, textAlign: 'right' }}>
                        <Button
                            onClick={() => {
                                setIsManualAchatModalOpen(false);
                                setModifierMontant(false);
                                setCouponSelectionne(null);
                            }}
                            style={{ marginRight: 8 }}
                        >
                            Annuler
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={submitting}
                            style={{ backgroundColor: 'var(--primary-color3)', borderColor: 'var(--primary-color3)' }}
                        >
                            Créer l'achat
                        </Button>
                    </div>
                </Form>
            </Modal>

            <BackupCodesModal
                isOpen={isBackupCodesModalOpen}
                onClose={() => setIsBackupCodesModalOpen(false)}
                backupCodes={backupCodes}
            />
            <ConfirmAchat
                isOpen={isConfirmAchatModalOpen}
                onClose={() => setIsConfirmAchatModalOpen(false)}
                achat={achat}
                onSuccess={loadAchats}
            />
            <ToastContainer
                draggable
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                pauseOnHover
            />
            <ImageModal
                imageUrl={imageUrl}
                open={isImageModalOpen}
                onClose={() => setIsImageModalOpen(false)}
            />

            {/* Modal for Unpaid Achats (Clicks) */}
            <Modal
                title="Liste des Clicks (Non payés)"
                open={isUnpaidModalOpen}
                onCancel={() => setIsUnpaidModalOpen(false)}
                footer={null}
                width={1000}
                styles={{
                    body: {
                        backgroundColor: "var(--background-body)",
                        color: "var(--primary-color)"
                    }
                }}
            >
                <div style={{ marginBottom: '16px' }}>
                    <Input
                        placeholder="Rechercher un click..."
                        value={unpaidFilters.search}
                        onChange={(e) => setUnpaidFilters(prev => ({ ...prev, search: e.target.value, currentPage: 1 }))}
                        style={{
                            backgroundColor: "var(--background-body)",
                            color: "var(--primary-color)",
                            border: "1px solid var(--primary-color6)",
                            borderRadius: '8px'
                        }}
                    />
                </div>
                <Table
                    dataSource={unpaidAchats}
                    loading={unpaidLoading}
                    rowKey="id"
                    columns={[
                        {
                            title: 'Acheteur',
                            dataIndex: 'acheteur',
                            key: 'acheteur',
                            render: (text, record) => (
                                <div>
                                    <p style={{ margin: 0, fontWeight: 'bold' }}>{record.acheteur?.username || 'N/A'}</p>
                                    <p style={{ margin: 0, fontSize: '12px' }}>{record.acheteur?.email || 'N/A'}</p>
                                </div>
                            ),
                        },
                        {
                            title: 'Offre',
                            dataIndex: 'offre',
                            key: 'offre',
                            render: (text, record) => (
                                <div>
                                    <Tag color="blue">{record.offre?.type?.nom || '--'}</Tag>
                                </div>
                            ),
                        },
                        {
                            title: 'Coins',
                            key: 'coins',
                            render: (text, record) => record.offre ? formateCoins(record.offre.coins) : '--',
                        },
                        {
                            title: 'Montant',
                            dataIndex: 'montant',
                            key: 'montant',
                            render: (text, record) => (
                                <span style={{ fontWeight: 'bold', color: '#1890ff' }}>
                                    {record.formatted_price ? record.formatted_price : (record.offre ? `${record.montant} ${record.currency_payment === 'EUR' ? '€' : '$'}` : '--')}
                                </span>
                            ),
                        },
                        {
                            title: 'Date',
                            dataIndex: 'date_achat',
                            key: 'date_achat',
                            render: (text) => formatDate(text),
                        }
                    ]}
                    pagination={{
                        current: unpaidFilters.currentPage,
                        total: unpaidTotalRows,
                        pageSize: unpaidFilters.perPage,
                        onChange: (page) => setUnpaidFilters(prev => ({ ...prev, currentPage: page })),
                        onShowSizeChange: (current, size) => setUnpaidFilters(prev => ({ ...prev, perPage: size, currentPage: 1 })),
                        showSizeChanger: true,
                    }}
                    scroll={{ x: 800 }}
                />
            </Modal>
        </>
    );
};

export default Achat;